export default "__VITE_ASSET__1579de8b__"